import { render, staticRenderFns } from "./YtMonetizationTab.vue?vue&type=template&id=49259933&scoped=true&"
import script from "./YtMonetizationTab.vue?vue&type=script&lang=js&"
export * from "./YtMonetizationTab.vue?vue&type=script&lang=js&"
import style0 from "./YtMonetizationTab.vue?vue&type=style&index=0&id=49259933&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49259933",
  null
  
)

export default component.exports